import { MULTIPLE_CHOICE_ID } from 'Constants/General';
import { v4 as uuidv4 } from 'uuid';
import {
  LessonCount,
  UserListUsersByCourse,
  UserListUsersByPrivateLesson,
  EvaluationQuestionList,
  EvaluationAnswerList,
} from './Request';

export const numberOfLessons = async ({ moduleId }) => {
  const { count } = await LessonCount({ moduleId });
  return count;
};

const mapUsers = users => users.map(user => ({ id: user.User.id, fullName: user.User.fullName }));

export const fetchCourseUsers = async ({ courseId, lessonId }) => {
  const promises = [];
  promises.push(UserListUsersByCourse({ courseId }));
  if (lessonId) {
    promises.push(UserListUsersByPrivateLesson({ lessonId }));
  }

  const data = await Promise.all(promises);

  const courseUsers = mapUsers(data[0]);
  if (lessonId) {
    const enrolledUsers = mapUsers(data[1]);
    const enrolledUsersIds = data[1].map(user => user.User.id);
    const filteredCourseUsers = courseUsers.filter(item => !enrolledUsersIds.includes(item.id));
    return { courseUsers: filteredCourseUsers, enrolledUsers };
  }

  return { courseUsers };
};

export const fetchEvaluationQuestions = async ({ lessonId }) => {
  const questions = await EvaluationQuestionList({ lessonId });
  const promises = [];
  if (!questions) {
    return [
      {
        id: `question_${uuidv4()}`,
        order: 1,
        answers: [
          {
            id: `question_0-answer_${uuidv4()}`,
            order: 1,
            isCorrect: false,
            response: '',
          },
        ],
        value: 1,
        question: 'Pregunta #1',
        evaluationQuestionTypeId: MULTIPLE_CHOICE_ID,
      },
    ];
  }

  for (let i = 0; i < questions.length; i += 1) {
    promises.push(
      EvaluationAnswerList({ evaluationQuestionId: questions[i].id }).then(answers => {
        questions[i].answers = answers;
        return null;
      })
    );
  }

  await Promise.allSettled(promises);
  return questions;
};

export default {
  numberOfLessons,
  fetchCourseUsers,
  fetchEvaluationQuestions,
};
